import { Box, Button, Step as MuiStep, StepLabel, Stepper } from "@mui/material";
import type { Step } from "./buildStepPlan";

export interface StepBarProps {
  steps: Step[];
  activeIndex: number;
  blockingErrors: number;
  isLastStep: boolean;
  isOptional: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
  onSkip: () => void;
  onAddArrayItem?: () => void;
  arrayAddLabel?: string;
  onSubmit: () => Promise<void> | void;
}

export const StepBar = ({
  steps,
  activeIndex,
  blockingErrors,
  isLastStep,
  isOptional,
  isSubmitting,
  onBack,
  onNext,
  onSkip,
  onAddArrayItem,
  arrayAddLabel,
  onSubmit,
}: StepBarProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, py: 1 }}>
      <Stepper activeStep={activeIndex} alternativeLabel>
        {steps.map((s) => (
          <MuiStep key={s.id} completed={false}>
            <StepLabel optional={s.isOptional ? <span>optional</span> : undefined}>
              {s.label}
            </StepLabel>
          </MuiStep>
        ))}
      </Stepper>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2 }}>
        <Button disabled={activeIndex === 0} onClick={onBack}>
          Back
        </Button>
        <Box sx={{ display: "flex", gap: 1 }}>
          {onAddArrayItem && arrayAddLabel && (
            <Button variant="outlined" onClick={onAddArrayItem}>
              + {arrayAddLabel}
            </Button>
          )}
          {isOptional && !isLastStep && <Button onClick={onSkip}>Skip</Button>}
          {isLastStep ? (
            <Button
              variant="contained"
              color="success"
              disabled={isSubmitting || blockingErrors > 0}
              onClick={() => onSubmit()}
            >
              {isSubmitting ? "Submitting…" : "Submit"}
            </Button>
          ) : (
            <Button
              variant="contained"
              disabled={blockingErrors > 0}
              onClick={onNext}
            >
              Next →
            </Button>
          )}
        </Box>
      </Box>
      {blockingErrors > 0 && (
        <Box sx={{ color: "#e57373", fontSize: 12, px: 2 }}>
          Fix {blockingErrors} {blockingErrors === 1 ? "error" : "errors"} in this step to continue.
        </Box>
      )}
    </Box>
  );
};
